import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';
import InputField from '../../components/InputField';
import CalculationResultPart from '../../components/CalculationResultPart';
import { Helmet } from "react-helmet-async";
import { Link } from 'react-router-dom';
import Header from '../../components/Header';

const faqs = [
    {
        question: "<h5>Islah Harcı Nedir?</h5>",
        answer: ["Islah harcı, dava bedelinin artırılması sonrasında ödenen harçtır. Bu harç, davanın bedelinin artırılan kısmının binde 68,31'inin dörtte biri olarak hesaplanır."],
    },
    {
        question: "<h5>Islah Harcı Nasıl Hesaplanır?</h5>",
        answer: [
            "Dava bedelinin başlangıçtaki tutarını belirleyin.",
            "Dava bedelinin artırılmak istenen tutarını belirleyin.",
            "Arttırılan bedel ile başlangıçtaki bedel arasındaki farkı hesaplayın.",
            "Farkı binde 68,31 ile çarpın.",
            "Elde edilen sonucu 4'e bölün.",
            "Bulunan tutar, ıslah harcı olarak ödenmesi gereken tutardır.",
        ],
    },
    {
        question: "<strong>Örnek:</strong><p>Dava bedelinin başlangıçta 10.000 TL olduğunu ve 110.000 TL'ye çıkarılmak istendiğini varsayalım.</p>",
        answer: ["Arttırılan bedel: 110.000 TL - 10.000 TL = 100.000 TL", "Islah harcı: (100.000 TL * 68,31) / 1000 / 4 = 1.707,75 TL"],
    },
    {
        question: "<h5>Islah Harcının Ödenmesi:</h5>",
        answer: ["Islah harcı, dava ıslah dilekçesi ile birlikte mahkeme veznesine yatırılır. Harç yatırılmadan dilekçenin kabulü mümkün değildir."],
    },
];

const IslahHarciHesaplama = () => {
	const [hideAll, setHideAll] = useState(false);
	const [results, setResults] = useState([]);
	const [calculated, setCalculated] = useState(false);

	const [davaBaslangicEsasDeger, setDavaBaslangicEsasDeger] = useState(null);
	const [talepYeniDeger, setTalepYeniDeger] = useState(null);

	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const query = new URLSearchParams(location.search);

		if (query.toString()) {
			const parsedResults = query.get('results');
			if (parsedResults) {
				setResults(JSON.parse(decodeURIComponent(atob(parsedResults))));
			}
            setDavaBaslangicEsasDeger(Number(decodeURIComponent(atob(query.get('davaBaslangicEsasDeger')))));
            setTalepYeniDeger(Number(decodeURIComponent(atob(query.get('talepYeniDeger')))));
			setCalculated(true);
		}
		
		localStorage.setItem('referrer', `${window.location.origin}${window.location.pathname}`);
	}, [location.search]);

	const calculate = () => {
		if (talepYeniDeger && davaBaslangicEsasDeger) {
            const newResults = [
                { text: "Islah Harcı", value: (talepYeniDeger - davaBaslangicEsasDeger) * (6831 / 100 / 1000 / 4) },
            ];

            setHideAll(true);

            const params = new URLSearchParams({
				results: btoa(encodeURIComponent(JSON.stringify(newResults))),
				talepYeniDeger: btoa(encodeURIComponent(talepYeniDeger.toString())),
				davaBaslangicEsasDeger: btoa(encodeURIComponent(davaBaslangicEsasDeger.toString())),
			});

			navigate(`${window.location.pathname}?${params.toString()}`);
			navigate(0);
		} else {
			alert("Lütfen tüm değerleri doğru girdiğinizden emin olunuz!");
		}
	};

    return (
        <>
            <Helmet>
                <title>Islah Harcı Hesaplama - Legalbul</title>
                <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
                <meta name="description" content="Islah harcı hesaplama, bir davada ıslah talebinin kabulü için ödenmesi gereken harcı belirlemek amacıyla yapılan bir işlemdir." />
            </Helmet>
            
            <Header />
            <section className="container my-5 bg-white shadow-sm p-0">
                <div className="p-4">
                    <ol className="breadcrumbnav">
                        <li>
                            <Link to="/">Ana Sayfa</Link>
                        </li>
                        <li>
                            <Link to="/hesaplamalar">Tüm Hesaplamalar</Link>
                        </li>
                        <li>Islah Harcı Hesaplama</li>
                    </ol>
                    <h1 className="fw-semibold">Islah Harcı Hesapla</h1>
                    <p>Islah harcı hesaplama, bir davada ıslah talebinin kabulü için ödenmesi gereken harcı belirlemek amacıyla yapılan bir işlemdir.</p>
                    
                    <InputField value={davaBaslangicEsasDeger} setValue={setDavaBaslangicEsasDeger} trailText="TL" label="Dava Başlangıcı Esas Değeri" type="number" />
                    <InputField value={talepYeniDeger} setValue={setTalepYeniDeger} trailText="TL" label="Talep Edilen Yeni Değer" type="number" />
                </div>

                <CalculationResultPart calculated={calculated} hideAll={hideAll} results={results} calculate={calculate} />
            </section>
            
            <Footer faqs={faqs} faqTitle="Islah Harcı Hakkında Bilmeniz Gerekenler" />
        </>
    );
};

export default React.memo(IslahHarciHesaplama);
